
import React, { useEffect } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface PhotoPositioningPreviewProps {
  imageSrc: string;
  yOffset: number;
  onYOffsetChange?: (value: number) => void;
  disabled?: boolean;
}

export const PhotoPositioningPreview: React.FC<PhotoPositioningPreviewProps> = ({
  imageSrc,
  yOffset = 0, // Default to 0 if yOffset is undefined
  onYOffsetChange,
  disabled = false
}) => {
  // Log when position changes
  useEffect(() => {
    console.log("PhotoPositioningPreview: yOffset updated to", yOffset);
  }, [yOffset]);

  // Ensure yOffset is always a number
  const safeYOffset = typeof yOffset === 'number' ? yOffset : 0;
  // Map yOffset [-1, 1] so positive shifts image DOWN; 0 => 50% (center)
  const cssPercent = 50 + (safeYOffset * 50);

  return (
    <div className="relative w-full">
      <AspectRatio ratio={2/1} className="bg-gray-100 border border-gray-300 overflow-hidden">
        <img 
          src={imageSrc} 
          alt="Preview" 
          className="object-cover w-full h-full"
          style={{ 
            objectPosition: `center ${cssPercent}%` 
          }}
        />
      </AspectRatio>
    </div>
  );
};
